import "./App.css";
import PrivateRoute from "./routes/PrivateRoute.js";
import { Route, Routes } from "react-router-dom";
import NotFound from "./components/NotFound/NotFound.js";
import SignIn from "./components/Auth/SignIn/SignIn.js";
import ForgotPassword from "./components/Auth/ForgotPassword/ForgotPassword.js";
import ResetPassword from "./components/Auth/ResetPassword/ResetPassword.js";
import NewSignIn from "./components/Auth/AdminSignIn/SignIn.js";
import PublicRoute from "./routes/PublicRoute.js";
import Main from "./components/Layout/Main/Main.js";
import * as links from "./utils/links.js";
import DashboardMaquinas from "./components/Main/Dashboard/DashboardMáquinas.js";
import { DashboardMaquinasPremium, MinhasMaquinasPremium, RelatoriosPremium, FinanceiroPremium, PromocoesPremium, AlertasPremium, EstrategiasPremium, PeluciasPremium, LocalizacoesPremium, ConfiguracoesPremium } from "./components/Main/Dashboard/DashboardMáquinas.js";
import ClientesDashboard from "./components/Main/Cliente/ClientesDashboard/ClientesDashboard.js";
import PagamentosSearch from "./components/Main/SearchPagamentos/PagamentosSearch.js";
import DeletePagamento from "./components/Main/SearchPagamentos/DeletePagamento.js";
import EditPagamento from "./components/Main/SearchPagamentos/EditPagamento.js";
import EditCliente from "./components/Main/Cliente/EditCliente/EditCliente.js";
import DeleteMaquina from "./components/Main/SearchPagamentos/DeleteMaquina.js";
import ClienteMaquinas from "./components/Main/Cliente/ClienteMaquinas/ClienteMaquinas.js";
import HelpPage from "./components/Main/HelpPage/HelpPage.js";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import React, { useContext, useEffect } from "react";
import { AuthContext } from "./contexts/AuthContext.js";
import AddMachine from "./components/Main/AddMachine/AddMachine.js";
import AddCliente from "./components/Main/Cliente/AddCliente/AddCliente.js";
import RemoteCredit from "./components/Main/RemoteCredit/RemoteCredit.js";
import DeleteCliente from "./components/Main/Cliente/DeleteCliente/DeleteCliente.js";
import Relatorio from "./components/Main/Relatorio/Relatorio/Relatorio.js";
import TokenHelpPage from "./components/Main/TokenHelpPage/TokenHelpPage.js";
import AdminPagamentosSearch from "./components/Main/Cliente/AdminSearchPagamentos/AdminPagamentosSearch.js";
import AdminEditPagamento from "./components/Main/Cliente/AdminSearchPagamentos/AdminEditPagamento.js";
import AdminDeletePagamento from "./components/Main/Cliente/AdminSearchPagamentos/AdminDeletePagamento.js";
import ConfigSignIn from "./components/Auth/Config/ConfigSignIn/ConfigSignIn.js";
import Trocar from "./components/Main/Cliente/Trocar/Trocar.js";
import AddMaquina from "./components/Main/Cliente/AddMaquina/AddMaquina.js";
import CreditoRemoto from "./components/Main/Cliente/CreditoRemoto/CreditoRemoto.js";
import RelatorioAdmin from "./components/Main/Cliente/RelatorioAdmin/RelatorioAdmin.js";
import AdminDeleteALLPagamentos from "./components/Main/Cliente/AdminSearchPagamentos/AdminDeleteALLPagamentos.js";
import RelatorioDispAdmin from "./components/Main/Cliente/RelatorioDispAdmin/RelatorioDispAdmin.js";
import RelatorioDisp from "./components/Main/Cliente/RelatorioDisp/RelatorioDisp.js";
import ListaMaquinas from "./components/Main/Cliente/ListaMaquinas/ListaMaquinas.js";
import ResetSenha from "./components/Main/Cliente/ResetSenha/ResetSenha.js";
import PagamentosCliente from "./components/Main/Cliente/PagamentosCliente/PagamentosCliente.js";
import MaqPagamentosAdm from "./components/Main/Cliente/MaqPagamentos/Adm/MaqPagamentosAdm.js";
import MaqPagamentosCliente from "./components/Main/Cliente/MaqPagamentos/Cliente/MaqPagamentosCliente.js";
import MensalidadesAdm from "./components/Main/Cliente/Mensalidades/Adm/MensalidadesAdm.js";
import MensalidadesAdmList from "./components/Main/Cliente/Mensalidades/Adm/MensalidadesAdmList.js";
import MensalidadesCliente from "./components/Main/Cliente/Mensalidades/Cliente/MensalidadesCliente.js";
import SignUp from "./components/Auth/SignUp/SignUp.js";
import LiberarCredito from "./components/Main/LiberarCredito/LiberarCredito.js";
import Auditoria from "./components/Main/Relatorio/Auditoria/AuditoriaMaquinas.js";
import DetalheAuditoria from "./components/Main/Relatorio/DetalheAuditoria/DetalheAuditoria.js";


function App() {
  const {
    setDataUser,
    loading,
    notiMessage,
    setNotiMessage,
    notiMessageInfo,
    setNotiMessageInfo,
    authInfo,
  } = useContext(AuthContext);

  const type = authInfo?.dataUser?.type;

  useEffect(() => {
    if (notiMessage) {
      setNotiMessage(null);

      switch (notiMessage.type) {
        case "error":
          NotificationManager.error(notiMessage.message, "Hmm... ");
          break;
        case "success":
          NotificationManager.success(notiMessage.message, "... ");
          break;
        case "info":
          NotificationManager.info(notiMessage.message, "... ");
          break;
        case "warning":
          NotificationManager.warning(notiMessage.message, "... ");
          break;
      }
    }
  }, [notiMessage]);

  // useEffect(() => {
  //     if (notiMessageInfo) {
  //         setNotiMessageInfo(null)
  //         NotificationManager.info(notiMessageInfo, '... ');
  //     }
  // }, [notiMessageInfo])

  return (
    <>
      <NotificationContainer />
      <Routes>
        <Route path="/liberar/:id" element={<LiberarCredito />} />
        {
          <>
            <Route
              path={`${links.FORNECEDOR_SEARCH_CANAIS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    {/* <PagamentosSearch /> */}
                    <MaqPagamentosCliente/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_FORNECEDOR_SEARCH}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    {/* <AdminPagamentosSearch /> */}
                    <MaqPagamentosAdm/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTE_MENSALIDADES_ADM}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <MensalidadesAdm/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTE_MENSALIDADES}`}
              element={
                <PrivateRoute>
                  <Main>
                    <MensalidadesCliente/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.MENSALIDADES_ADM_LIST}`}
              element={
                <PrivateRoute>
                  <Main>
                    <MensalidadesAdmList/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTE_PAGAMENTOS}`}
              element={
                <PrivateRoute>
                  <Main>
                    <PagamentosCliente/>
                    {/* <Dashboard/> */}
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CREDITO_REMOTO_ADM}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <CreditoRemoto />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.EDIT_FORNECEDOR_CANAIS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <EditPagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_EDIT_FORNECEDOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AdminEditPagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_TROCAR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <Trocar />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.ADD_CLIENTES_MAQUINA_ADM}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AddMaquina />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.EDITAR_CLIENTES}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <EditCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.DELETE_FORNECEDOR_CANAIS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <DeletePagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_DELETE_FORNECEDOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AdminDeletePagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINA_DELETE_PAGAMENTOS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AdminDeleteALLPagamentos />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.DELETE_CLIENTE}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <DeleteCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <Relatorio />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO_ADMIN}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <RelatorioAdmin />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO_DISP_ADMIN}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <RelatorioDispAdmin/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO_DISP}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <RelatorioDisp/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <ClienteMaquinas />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.DELETE_FORNECEDOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <DeleteMaquina />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.HELP_PAGE}`}
              element={
                <PrivateRoute>
                  <Main>
                    <HelpPage />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.TOKEN_HELP_PAGE}`}
              element={
                <PrivateRoute>
                  <Main>
                    <TokenHelpPage />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.DASHBOARD_FORNECEDOR}
              element={
                <PrivateRoute>
                  <Main>
                    <DashboardMaquinas></DashboardMaquinas>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.DASHBOARD_FORNECEDOR_PREMIUM}
              element={
                <PrivateRoute>
                  <Main>
                    <DashboardMaquinasPremium />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.MINHAS_MAQUINAS_PREMIUM}
              element={
                <PrivateRoute>
                  <Main>
                    <MinhasMaquinasPremium />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.RELATORIOS_PREMIUM}
              element={
                <PrivateRoute>
                  <Main>
                    <RelatoriosPremium />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.FINANCEIRO_PREMIUM}
              element={
                <PrivateRoute>
                  <Main>
                    <FinanceiroPremium />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.PROMOCOES_PREMIUM}
              element={
                <PrivateRoute>
                  <Main>
                    <PromocoesPremium />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.ALERTAS_PREMIUM}
              element={
                <PrivateRoute>
                  <Main>
                    <AlertasPremium />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.ESTRATEGIAS_PREMIUM}
              element={
                <PrivateRoute>
                  <Main>
                    <EstrategiasPremium />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.PELUCIAS_PREMIUM}
              element={
                <PrivateRoute>
                  <Main>
                    <PeluciasPremium />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.LOCALIZACOES_PREMIUM}
              element={
                <PrivateRoute>
                  <Main>
                    <LocalizacoesPremium />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.CONFIGURACOES_PREMIUM}
              element={
                <PrivateRoute>
                  <Main>
                    <ConfiguracoesPremium />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.DASHBOARD_CLIENTES}
              element={
                <PrivateRoute>
                  <Main>
                    <ClientesDashboard />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.LISTA_MAQUINAS}
              element={
                <PrivateRoute>
                  <Main>
                    <ListaMaquinas/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.NEW_PASSWORD}
              element={
                <PrivateRoute>
                  <Main>
                    <ResetSenha/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.ADD_MACHINE}
              element={
                <PrivateRoute>
                  <Main>
                    <AddMachine />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.ADD_CLIENTES}
              element={
                <PrivateRoute>
                  <Main>
                    <AddCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.REMOTE_CREDIT}
              element={
                <PrivateRoute>
                  <Main>
                    <RemoteCredit />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.AUDITORIA}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <Auditoria />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.DETALHE_AUDITORIA}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <DetalheAuditoria />
                  </Main>
                </PrivateRoute>
              }
            />
          </>
        }
        <Route
          path={links.SIGNIN}
          element={
            <PublicRoute>
              <SignIn />
            </PublicRoute>
          }
        />
         <Route
          path={links.SIGNUP_CANAL}
          element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          }
        />
        <Route
          path={links.FORGOTPASSWORD}
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path={links.RESETPASSWORD}
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />
        <Route
          path={links.ADMIN_SIGNIN}
          element={
            <PublicRoute>
              <NewSignIn />
            </PublicRoute>
          }
        />
        <Route
          path={links.CONFIG}
          element={
            <PublicRoute>
              <ConfigSignIn />
            </PublicRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
